import React, { Component } from "react";

import { API_RESPONSE_CODE } from "../../constants/apiResponseCode.constants";

import WPErrorFullPage from "../../packages/WPErrorFullPage";

class WPErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      errorCode: null,
    };
  }

  static getDerivedStateFromError() {
    return {
      hasError: true,
      errorCode: API_RESPONSE_CODE.APP_CRASH,
    };
  }

  componentDidCatch(error, errorInfo) {
    // Keep a console trace for debugging unexpected render/runtime crashes.
    // eslint-disable-next-line no-console
    console.error("App crashed in WPErrorBoundary", error, errorInfo);
  }

  render() {
    const { children } = this.props;
    const { hasError, errorCode } = this.state;

    if (hasError) {
      return <WPErrorFullPage errorCode={errorCode} />;
    }

    return children;
  }
}

export default WPErrorBoundary;
